import React from "react";
import SignUpForm from "./SignUpForm";
import LoginBanner from "./LoginBanner";
import { connect } from "react-redux";
import { userSignupRequest } from "../../modules/actions/signupActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import StayTouch from "../../layout/StayTouch";
import AuthBanner from "../../reusable/AuthBanner";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
class SignUpPage extends React.Component {
  render() {
    const { userSignupRequest, addFlashMessage } = this.props;
    return (
      <div>
        {/* <AuthBanner title="Get WiFi Anywhere! Anytime!" /> */}
        <SignUpForm
          userSignupRequest={userSignupRequest}
          addFlashMessage={addFlashMessage}
        />
        {/* <LoginBanner /> */}
        <StayTouch />
      </div>
    );
  }
}

export default connect(
  null,
  { userSignupRequest, addFlashMessage }
)(layoutWrapper(SignUpPage));



// WEBPACK FOOTER //
// ./src/pages/signup/index.js